var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 21.3333L15.9998 16L10.6665 21.3333",
    stroke: "#094D96",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16V28",
    stroke: "#094D96",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1866 24.52C28.4871 23.811 29.5144 22.6892 30.1064 21.3315C30.6985 19.9738 30.8216 18.4576 30.4562 17.0222C30.0909 15.5869 29.2579 14.314 28.0888 13.4046C26.9198 12.4952 25.4811 12.001 23.9999 12H22.3199C21.9164 10.439 21.1642 8.98977 20.1199 7.76131C19.0756 6.53286 17.7664 5.55712 16.2907 4.90747C14.8151 4.25781 13.2113 3.95113 11.6001 4.0105C9.98886 4.06986 8.41204 4.49372 6.98818 5.25021C5.56433 6.0067 4.3305 7.07613 3.37944 8.3781C2.42839 9.68007 1.78487 11.1807 1.49725 12.7672C1.20964 14.3537 1.28542 15.9847 1.7189 17.5377C2.15238 19.0906 2.93227 20.5251 3.99995 21.7333",
    stroke: "#094D96",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.c93bac08e4e63b20b80ce618617bdb10.svg";
export { ForwardRef as ReactComponent };